<template>
  <modal name="update-reseller" class="modal-inner modal-update-reseller" transition="pop-out" :width="modalWidth" :focus-trap="true" :min-height="600" height="auto" :scrollable="true">
    <span class="close-button" @click="hide('update-reseller')"><BaseIcon icon="times-circle" class="text-white"/></span>
    <div class="modal-header text-lg bg-primary-50 font-serif">
      <span v-if="updateInfo">{{ updateInfo.name }}</span>
    </div>
    <div class="modal-body">
      <ValidationObserver ref="formUpdateReseller" v-if="updateInfo != null">
        <div v-if="user.role == 'admin'" class="flex flex-wrap">
          <div class="w-full md:w-1/3 px-2 py-2">
            <BaseSelect v-model="updateInfo.reseller_type" :options="resellerTypes" nameSelector="name" optionSelector="id" :field_name="$t('reseller_edit_modal.type')" />
          </div>
          <div v-if="updateInfo.reseller_type == 'alarm_center'" class="w-full md:w-1/3 px-2 py-2">
            <BaseSelect v-model="updateInfo.alarm_center" :options="alarmCenters" nameSelector="name" optionSelector="_id" :field_name="$t('reseller_edit_modal.alarm_center')" rules="required" />
          </div>
        </div>

        <div v-if="user.role == 'admin'" class="mx-2 border-b border-secondary-400 my-5"></div>
        <div class="flex flex-wrap">
          <div class="w-full md:w-1/3 px-2 py-2">
            <BaseInput v-model="updateInfo.name" type="text" :field_name="$t('reseller_edit_modal.name')" rules="required" />
          </div>
          <div class="w-full md:w-1/3 px-2 py-2">
            <BaseInput v-model="updateInfo.company_number" type="text" :field_name="$t('reseller_edit_modal.org_number')" rules="required" />
          </div>
        </div>

        <div class="mx-2 border-b border-secondary-400 my-5"></div>
        <div class="flex flex-wrap">
          <div class="w-full md:w-1/3 px-2 py-2">
            <BaseInput v-model="updateInfo.email" type="text" :field_name="$t('reseller_edit_modal.email')" rules="required" />
          </div>
          <div class="w-full md:w-1/3 px-2 py-2">
            <BaseInput v-model="updateInfo.phone" type="text" :field_name="$t('reseller_edit_modal.phone')" rules="required" />
          </div>
        </div>

        <div class="mx-2 border-b border-secondary-400 my-5"></div>
        <div class="flex flex-wrap">
          <div class="w-full md:w-1/3 px-2 py-2">
            <BaseInput v-model="updateInfo.address" type="text" :field_name="$t('reseller_edit_modal.address')" rules="required" />
          </div>
          <div class="w-full md:w-1/3 px-2 py-2">
            <BaseInput v-model="updateInfo.zip_code" type="text" :field_name="$t('reseller_edit_modal.zip_code')" rules="required" />
          </div>
          <div class="w-full md:w-1/3 px-2 py-2">
            <BaseInput v-model="updateInfo.city" type="text" :field_name="$t('reseller_edit_modal.city_town')" rules="required" />
          </div>
          <div class="w-full md:w-1/3 px-2 py-2" v-if="user.role == 'admin'">
            <BaseInput v-model="updateInfo.reference" type="text" :field_name="$t('reseller_edit_modal.ref')" rules="required" />
          </div>
          <div class="w-full md:w-1/3 px-2 py-2">
            <BaseInput v-model="updateInfo.invoice" type="text" :field_name="$t('reseller_edit_modal.e_invoice')" rules="required" />
          </div>
        </div>

        <div class="mx-2 border-b border-secondary-400 my-5"></div>
        <div class="flex flex-wrap">
          <div class="w-full md:w-1/3 px-2 py-2">
            <BaseInput v-model="updateInfo.contact_person" type="text" :field_name="$t('reseller_edit_modal.contact_person')" rules="required" />
          </div>
          <div class="w-full md:w-1/3 px-2 py-2">
            <BaseInput v-model="updateInfo.contact_email" type="text" :field_name="$t('reseller_edit_modal.contact_email')" rules="required" />
          </div>
          <div class="w-full md:w-1/3 px-2 py-2">
            <BaseInput v-model="updateInfo.contact_phone" type="text" :field_name="$t('reseller_edit_modal.contact_phone')" rules="required" />
          </div>
        </div>

        <div class="mx-2 border-b border-secondary-400 my-5"></div>
            <div class="flex flex-wrap">
              <div class="w-full md:w-3/3 px-2 py-2">
                <BaseTextarea rows="5" v-model="updateInfo.description" :field_name="$t('reseller_edit_modal.description')" rules="required" />
              </div>
            </div>

            <!-- White-label options -->
            <div v-if="user.role == 'admin'" class="mx-2 border-b border-secondary-400 my-5"></div>
            <div v-if="user.role == 'admin'" class="flex flex-wrap">
              <div v-if="user.role == 'admin' && previewImage" class="w-full px-2 py-2">
                <p>{{ $t('reseller_edit_modal.current_logo') }}</p>
                <img :src="previewImage" class="px-2 py-2 max-h-28" />
              </div>
              <div v-if="user.role == 'admin'" class="w-full px-2 py-2">
                  <p>{{ $t('reseller_edit_modal.whitelabel_description') }}</p>
              </div>
            </div>
            <div v-if="user.role == 'admin'" class="flex flex-wrap px-2 py-2">
              <div v-if="user.role == 'admin'" class="w-1/3 md:w-1/3 px-2 py-2">
                <ValidationProvider name="White-label" rules="required" v-slot="{ classes, errors }">
                  <div class="input-validate" :class="classes">
                    <label class="text-gray-700 text-sm font-bold pb-2 font-serif">{{ $t("reseller_edit_modal.white-label") }}<b class="text-red-500 ml-1">*</b></label>
                    <select v-model="updateInfo.whitelabel" @change="onWhitelabelChange()" class="bg-gray-100 rounded w-full text-sm text-gray-900 focus:outline-none border-b-4 border-gray-300 transition duration-500 px-3 pt-2 pb-2 hover:border-gray-400">
                      <option :value="o['value']" v-for="(o, i) in whitelabeloptions" :key="i">{{ o["name"] }}</option>
                    </select>
                    <span>{{ errors[0] }}</span>
                  </div>
                </ValidationProvider>
              </div>
              <!-- SEC-334: with White-label on, this reseller shows its own brand on its own
                   web addresses, and its customers and users inherit it -->
              <div v-if="updateInfo.whitelabel" class="w-1/3 md:w-1/3 px-2 py-2">
                <label class="text-gray-700 text-sm font-bold pb-2 font-serif">{{ $t("brands_page.configuration") }}<b class="text-red-500 ml-1">*</b></label>
                <button class="btn-blue-outline w-full px-3 py-2" @click.prevent="openBrandConfiguration()">
                  {{ brandingComplete ? $t("brands_page.configuration_edit") : $t("brands_page.configuration_add") }}
                  <BaseIcon icon="palette" class="ml-1" />
                </button>
                <p v-if="!brandingComplete" class="text-xs text-red-500 mt-1">{{ $t("brands_page.configuration_missing") }}</p>
              </div>
            </div>
            <!-- End of White-label options-->
        <div v-if="user.role == 'admin'" class="mx-2 border-b border-secondary-400 my-5"></div>
        <div class="flex flex-wrap" v-if="user.role == 'admin'">
          <div class="w-full md:w-1/3 px-2 py-2" v-for="o in updateInfo.pricelist" :key="o.id">
            <div class="w-full text-md font-bold mb-4">
              <label class="inline-flex items-center mt-3">
                <input v-model="o.active" type="checkbox" class="form-checkbox h-4 w-4" />
                <span class="ml-2 text-gray-600 text-md font-serif font-bold" v-if="o.id == 'cash'">{{ $t("reseller_edit_modal.cash") }}</span>
                <span class="ml-2 text-gray-600 text-md font-serif font-bold" v-else-if="o.id == 'rental'">{{ $t("reseller_edit_modal.for_rent") }}</span>
                <span class="ml-2 text-gray-600 text-md font-serif font-bold" v-else-if="o.id == 'kickback'">{{ $t("reseller_edit_modal.kickback") }}</span>
              </label>
            </div>
            <div v-if="o.active">
              <div class="w-full text-md font-sans font-semibold mt-5 mb-6">
                <span v-if="o.id == 'cash'">{{ $t("reseller_edit_modal.cash") }}</span>
                <span v-else-if="o.id == 'rental'">{{ $t("reseller_edit_modal.for_rent") }}</span>
                <span v-else-if="o.id == 'kickback'">{{ $t("reseller_edit_modal.kickback") }}</span>
                {{ $t("reseller_edit_modal.price_list") }}
              </div>
              <div class="flex flex-wrap my-2" v-for="p in o.prices" :key="p.id">
                <div class="w-2/6 text-sm" v-bind:class="{ 'opacity-40': p.price == 0 }">
                  {{ p.name }}
                </div>
                <div class="w-2/6" v-bind:class="{ 'opacity-40': p.price == 0 }">
                  <ValidationProvider :name="p.name" rules="required" v-slot="{ classes, errors }">
                    <div class="input-validate" :class="classes">
                      <input type="number" v-model="p.price" min="0" class="bg-gray-100 rounded w-full text-sm text-gray-900 focus:outline-none border-b-2 border-gray-300 transition duration-500 px-3 pt-1 pb-1" />
                      <span>{{ errors[0] }}</span>
                    </div>
                  </ValidationProvider>
                </div>
                in
                <div class="w-1/6" v-bind:class="{ 'opacity-40': p.price == 0 }">
                  <span class="pl-2 text-xs" v-if="p.price_type == 'month'"> / {{ $t("reseller_edit_modal.month") }}</span>
                </div>
                <div class="w-1/6">
                  <span v-if="p.price != 0" @click.prevent="setPriceZero(o.id, p.id)" class="cursor-pointer text-xs"><BaseIcon icon="times-circle" class="text-red-400"/></span>
                  <span v-else @click.prevent="resetSchemePrices(o.id, p.id)" class="cursor-pointer text-xs"><BaseIcon icon="redo" class="text-red-400"/></span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div v-if="user.role == 'admin'" class="mx-2 border-b border-secondary-400 my-5"></div>
        <div v-if="user.role == 'admin'" class="flex flex-wrap">
          <div class="w-full font-bold text-md px-2 py-2">{{ $t("reseller_edit_modal.special_access") }}</div>
          <template v-for="s in specialAccess">
            <div class="w-full md:w-1/3 px-2 py-2" v-bind:key="s.id">
              <label class="inline-flex items-center mt-3">
                <input v-model="updateInfo.special_access" :value="s.id" type="checkbox" class="form-checkbox h-4 w-4" />
                <span class="ml-2 text-gray-600 text-sm font-serif font-bold">{{ s.name }}</span>
              </label>
            </div>
          </template>
        </div>
          </ValidationObserver>
    </div>
    <BrandConfiguration ref="brandConfiguration" @apply="onBrandingApplied" />

    <div class="modal-footer">
      <div class="footer-container clearfix">
        <button class="btn-red-outline px-3 py-2 float-left" @click="hide('update-reseller')">{{ $t("user_actions.cancel") }}<BaseIcon icon="times-circle" class="ml-1" /></button>
        <button class="btn-green px-3 py-2 float-right" @click="updateReseller()">{{ $t("user_actions.save") }}<BaseIcon icon="save" class="ml-1" /></button>
      </div>
    </div>
  </modal>
</template>

<script>
import BrandConfiguration from "@/components/reseller/brand_configuration";

const MODAL_WIDTH = 1100;

export default {
  components: { BrandConfiguration },
  props: {
    resellerInfo: {
      required: true,
      default: null,
    },
  },
  data() {
    return {
      // SEC-334: the brand configuration of this reseller, collected by the modal and
      // saved together with the reseller below
      branding: null,
      whitelabelAtOpen: false, // white label was on when this reseller was opened
      brandingLogoFiles: {},
      brandingLogoPreviews: {},
      updateInfo: null,
      updateImage: null,
      previewImage: null,
      alternativ_order_email: "",
      alternativ_error_email: "",
      whitelabel: false,
      alarmCenters: [],
      pricelist: [
        {
          id: "cash",
          active: false,
          prices: [
            { id: "SRT306", name: "SRT306", price: "3450", price_type: "total" },
            { id: "SRT306i", name: "SRT306i", price: "4625", price_type: "total" },
            { id: "SRT306-G2", name: "SRT306 G2", price: "3850", price_type: "total" },
            { id: "SRT326", name: "SRT326", price: "2780", price_type: "total" },
            { id: "SRT330", name: "SRT330", price: "5900", price_type: "total" },
            { id: "SRT334", name: "SRT334", price: "1670", price_type: "total" },
            { id: "SRT405", name: "SRT405", price: "4373", price_type: "total" },
            { id: "SRT405i", name: "SRT405i", price: "0", price_type: "total" },
            { id: "SRT406", name: "SRT406", price: "4601", price_type: "total" },
            { id: "SRT406i", name: "SRT406i", price: "5191", price_type: "total" },
            { id: "SRT430", name: "SRT430", price: "0", price_type: "total" },
            { id: "SRT278", name: "SRT278", price: "0", price_type: "total" },
            { id: "SRT341", name: "SRT341", price: "0", price_type: "total" },
            { id: "TWIG-Neo", name: "TWIG Neo", price: "2500", price_type: "total" },
            { id: "TWIG-IPS", name: "TWIG Neo SRD", price: "4625", price_type: "total" },
            { id: "TWIG-Neo-Mandown", name: "TWIG Neo MD", price: "3175", price_type: "total" },
            { id: "TWIG-Neo-SRD-MD", name: "TWIG Neo SRD MD", price: "0", price_type: "total" },
            { id: "TWIG-One-GPS", name: "TWIG One", price: "4625", price_type: "total" },
            { id: "TWIG-One-SRD", name: "TWIG One SRD", price: "4625", price_type: "total" },
            { id: "TWIG-One-EX", name: "TWIG One EX", price: "4625", price_type: "total" },
            { id: "TWIG-Beacon", name: "TWIG Beacon", price: "1670", price_type: "total" },
            { id: "TWIG-Beacon-EX", name: "TWIG Beacon EX", price: "0", price_type: "total" },
            { id: "EMERIT-WG100", name: "EMERIT WG100", price: "0", price_type: "total" },
            { id: "EMERIT-WG200", name: "EMERIT WG200", price: "0", price_type: "total" },
            { id: "EMERIT-WG200-G", name: "EMERIT WG200-G", price: "0", price_type: "total" },
            { id: "TELTONIKA-FMC003", name: "TELTONIKA FMC003", price: "0", price_type: "total" },
            { id: "AnchorBeacon", name: "Anchor Beacon 2", price: "0", price_type: "month" },
            { id: "SecurBas", name: "SecurBas", price: "20", price_type: "month" },
            { id: "SecurFull", name: "SecurFull", price: "109", price_type: "month" },
            { id: "SecurdiaCare", name: "SecurdiaCare", price: "19", price_type: "month" },
            { id: "Simkort", name: "Simkort", price: "20", price_type: "month" },
            { id: "Larmcentral", name: "Larmcentral", price: "69", price_type: "month" },
          ],
        },
        {
          id: "rental",
          active: false,
          prices: [
            { id: "SRT306", name: "SRT306", price: "278", price_type: "month" },
            { id: "SRT306i", name: "SRT306i", price: "278", price_type: "month" },
            { id: "SRT306-G2", name: "SRT306 G2", price: "309", price_type: "month" },
            { id: "SRT326", name: "SRT326", price: "268", price_type: "month" },
            { id: "SRT330", name: "SRT330", price: "379", price_type: "month" },
            { id: "SRT334", name: "SRT334", price: "69", price_type: "month" },
            { id: "SRT405", name: "SRT405", price: "309", price_type: "month" },
            { id: "SRT405i", name: "SRT405i", price: "0", price_type: "month" },
            { id: "SRT406", name: "SRT406", price: "309", price_type: "month" },
            { id: "SRT406i", name: "SRT406i", price: "309", price_type: "month" },
            { id: "SRT430", name: "SRT430", price: "0", price_type: "month" },
            { id: "SRT278", name: "SRT278", price: "0", price_type: "month" },
            { id: "SRT341", name: "SRT341", price: "0", price_type: "month" },
            { id: "TWIG-Neo", name: "TWIG Neo", price: "219", price_type: "month" },
            { id: "TWIG-IPS", name: "TWIG Neo SRD", price: "278", price_type: "month" },
            { id: "TWIG-Neo-Mandown", name: "TWIG Neo MD", price: "219", price_type: "month" },
            { id: "TWIG-Neo-SRD-MD", name: "TWIG Neo SRD MD", price: "0", price_type: "month" },
            { id: "TWIG-One-GPS", name: "TWIG One", price: "278", price_type: "month" },
            { id: "TWIG-One-SRD", name: "TWIG One SRD", price: "278", price_type: "month" },
            { id: "TWIG-One-EX", name: "TWIG One EX", price: "278", price_type: "month" },
            { id: "TWIG-Beacon", name: "TWIG Beacon", price: "69", price_type: "month" },
            { id: "TWIG-Beacon-EX", name: "TWIG Beacon EX", price: "0", price_type: "month" },
            { id: "EMERIT-WG100", name: "EMERIT WG100", price: "0", price_type: "month" },
            { id: "EMERIT-WG200", name: "EMERIT WG200", price: "0", price_type: "month" },
            { id: "EMERIT-WG200-G", name: "EMERIT WG200-G", price: "0", price_type: "month" },
            { id: "TELTONIKA-FMC003", name: "TELTONIKA FMC003", price: "0", price_type: "month" },
            { id: "AnchorBeacon", name: "Anchor Beacon 2", price: "0", price_type: "month" },
            { id: "SecurBas", name: "SecurBas", price: "20", price_type: "month" },
            { id: "SecurFull", name: "SecurFull", price: "89", price_type: "month" },
            { id: "SecurdiaCare", name: "SecurdiaCare", price: "19", price_type: "month" },
            { id: "Simkort", name: "Simkort", price: "20", price_type: "month" },
            { id: "Larmcentral", name: "Larmcentral", price: "69", price_type: "month" },
          ],
        },
        {
          id: "kickback",
          active: false,
          prices: [
            { id: "60-month", name: "60 månader", price: "5000", price_type: "total" },
            { id: "36-month", name: "36 månader", price: "3000", price_type: "total" },
          ],
        },
      ],
    };
  },

  watch: {
    resellerInfo(newVal) {
      // eslint-disable-line
      this.updateInfo = _.cloneDeep(newVal);
      this.previewImage = this.updateInfo.logo;
      // SEC-334: the brand configuration of this reseller, if it has one
      this.branding = null;
      this.whitelabelAtOpen = Boolean(this.updateInfo.whitelabel);
      this.brandingLogoFiles = {};
      this.brandingLogoPreviews = {};
      if (this.updateInfo.whitelabel && this.updateInfo._id) this.loadBranding();
      // check for missing price scheme
      if (this.updateInfo.pricelist.length < this.pricelist.length) {
        // check & sort in predefined order
        let cash = _.find(this.updateInfo.pricelist, { id: "cash" });
        let rental = _.find(this.updateInfo.pricelist, { id: "rental" });
        let kickback = _.find(this.updateInfo.pricelist, { id: "kickback" });

        if (!cash) {
          let c = _.find(this.pricelist, { id: "cash" });
          this.updateInfo.pricelist.push(_.cloneDeep(c));
        }
        if (!rental) {
          let r = _.find(this.pricelist, { id: "rental" });
          this.updateInfo.pricelist.push(_.cloneDeep(r));
        }
        if (!kickback) {
          let k = _.find(this.pricelist, { id: "kickback" });
          this.updateInfo.pricelist.push(_.cloneDeep(k));
        }

        this.updateInfo.pricelist.sort((a, b) => (a.id.length > b.id.length ? 1 : -1));
      }
    },
  },

  computed: {
    // Read on every render, so the labels follow the language switcher instead of staying
    // in whatever language the page happened to open in
    whitelabeloptions() {
      return [
        { name: this.$t("reseller_edit_modal.yes"), value: true },
        { name: this.$t("reseller_edit_modal.no"), value: false },
      ];
    },
    // A reseller with White-label on needs its branding filled in before it can be saved:
    // without a web address and a company to show, there is no brand to serve.
    brandingComplete() {
      const b = this.branding;
      if (!b) return false;
      return Boolean((b.hosts || []).length && b.portalUrl && b.contact && b.contact.companyName);
    },
    user() {
      return this.$store.state.user;
    },
    resellerTypes() {
      return [{ id: "alarm_center", name: this.$t("reseller_edit_modal.alarm_center") }];
    },
    specialAccess() {
      return [
        { id: "order_sc_qty_default", name: this.$t("reseller_edit_modal.quality_enabled"), active: false },
        { id: "config", name: this.$t("reseller_edit_modal.configure_alarms"), active: false },
        { id: "alarm_report", name: this.$t("reseller_edit_modal.alarm_report"), active: false },
        { id: "create_customer", name: this.$t("reseller_edit_modal.create_customer"), active: false },
        { id: "users", name: this.$t("reseller_edit_modal.user"), active: false },
        { id: "sc_device_setting", name: this.$t("reseller_edit_modal.additional_services"), active: false },
        { id: "securtrack", name: this.$t("reseller_edit_modal.secur_track"), active: false },
        { id: "securtool", name: this.$t("reseller_edit_modal.secur_tool"), active: false },
        { id: "test_reminder", name: this.$t("reseller_edit_modal.alarm_reminder"), active: false },
        { id: "ac_securtrack", name: this.$t("reseller_edit_modal.alarm_centers_securTrack"), active: false },
        { id: "ac_securtool", name: this.$t("reseller_edit_modal.alarm_centers_securTool"), active: false },
      ];
    },
  },

  methods: {
    // SEC-334: turning White-label off throws away everything the brand configuration
    // holds, so the admin is asked first. Cancelling puts the answer back to Yes.
    onWhitelabelChange() {
      if (this.updateInfo.whitelabel) return;

      // Ask whenever this reseller had white label on when it was opened. Deciding from
      // the branding we managed to read would skip the question when that read failed,
      // and then a save would delete a live brand without anyone being asked.
      if (!this.whitelabelAtOpen) return;

      this.updateInfo.whitelabel = true; // stays on until the question is answered
      this.$modal.show("dialog", {
        title: this.$t("brands_page.whitelabel_off_title"),
        text: this.$t("brands_page.whitelabel_off_text"),
        buttons: [
          { title: this.$t("brands_page.cancel"), handler: () => this.$modal.hide("dialog") },
          {
            title: this.$t("brands_page.whitelabel_off_confirm"),
            class: "vue-dialog-button text-red-600",
            handler: () => {
              this.$modal.hide("dialog");
              this.updateInfo.whitelabel = false;
              this.branding = null;
              this.brandingLogoFiles = {};
              this.brandingLogoPreviews = {};
            },
          },
        ],
      });
    },
    // SEC-334: read what is already stored, then open the configuration modal
    async openBrandConfiguration() {
      if (!this.branding && this.updateInfo && this.updateInfo._id) await this.loadBranding();
      this.$refs.brandConfiguration.open(this.branding, this.updateInfo, this.brandingLogoFiles, this.brandingLogoPreviews);
    },
    async loadBranding() {
      try {
        const { data } = await this.axios.get(`${process.env.VUE_APP_SERVER_URL}/reseller/${this.updateInfo._id}/branding`);
        this.branding = data.data.branding && Object.keys(data.data.branding).length ? data.data.branding : null;
      } catch (error) {
        this.handleError(error);
      }
    },
    onBrandingApplied({ branding, reseller, logoFiles, logoPreviews }) {
      this.branding = branding;
      this.brandingLogoFiles = logoFiles || {};
      this.brandingLogoPreviews = logoPreviews || {};
      // the order and fault-report addresses are saved on the reseller itself
      if (reseller) {
        this.updateInfo.alternativ_order_email = reseller.alternativ_order_email;
        this.updateInfo.alternativ_error_email = reseller.alternativ_error_email;
      }
      // the left-menu logo is the one shown on this form
      const menuLogo = this.brandingLogoPreviews.menu || (branding && branding.logos && branding.logos.menu);
      if (menuLogo) this.previewImage = menuLogo;
    },
    // Saved after the reseller itself, so a brand new reseller already has an id
    async saveBranding(resellerId) {
      const base = `${process.env.VUE_APP_SERVER_URL}/reseller/${resellerId}/branding`;
      await this.axios.put(base, this.branding);

      for (const type of Object.keys(this.brandingLogoFiles)) {
        const formData = new FormData();
        formData.append("image", this.brandingLogoFiles[type]);
        try {
          await this.axios.post(`${base}/logo/${type}`, formData);
        } catch (error) {
          this.handleError(error, this.$t("brands_page.logo_upload_failed", { type }));
        }
      }
      this.brandingLogoFiles = {};
    },
    getAlarmCenters() {
      this.axios
        .get(`${process.env.VUE_APP_SERVER_URL}/alarm-central`)
        .then((response) => {
          this.alarmCenters = response.data.data;
        })
        .catch((error) => {
          this.handleError(error);
        });
    },

    updateReseller() {
      this.$refs.formUpdateReseller.validate().then((success) => {
        if (!success) {
          return;
        }

        let pricelist = [];

        for (let i = 0; i < this.updateInfo.pricelist.length; i++) {
          let o = this.updateInfo.pricelist[i];

          if (o.active) pricelist.push(o);
        }

        if (pricelist.length == 0) {
          this.handleError(null, "Vänligen välj minst ett prisupplägg");
          return;
        }

        // SEC-334: White-label on means this reseller serves its own brand, which cannot
        // be done with an empty configuration
        if (this.updateInfo.whitelabel && !this.brandingComplete) {
          this.handleError(null, this.$t("brands_page.configuration_missing"));
          return;
        }


        let headers = {
          "Content-Type": "multipart/form-data",
          "X-Access-Token": this.$store.state.token,
        };

        var formData = new FormData();

        let alarm_center = this.updateInfo.alarm_center;
        let special_access = this.updateInfo.special_access;

        if (this.updateInfo.reseller_type != "alarm_center") {
          alarm_center = "";

          if (special_access.indexOf("ac_securtrack") > -1) special_access.splice(special_access.indexOf("ac_securtrack"), 1);
          if (special_access.indexOf("ac_securtool") > -1) special_access.splice(special_access.indexOf("ac_securtool"), 1);
        }

        formData.append("name", this.updateInfo.name);
        formData.append("email", this.updateInfo.email);
        formData.append("phone", this.updateInfo.phone);
        formData.append("description", this.updateInfo.description);
        formData.append("company_number", this.updateInfo.company_number);
        formData.append("address", this.updateInfo.address);
        formData.append("zip_code", this.updateInfo.zip_code);
        formData.append("city", this.updateInfo.city);
        formData.append("reference", this.updateInfo.reference);
        formData.append("invoice", this.updateInfo.invoice);
        formData.append("contact_person", this.updateInfo.contact_person);
        formData.append("contact_phone", this.updateInfo.contact_phone);
        formData.append("contact_email", this.updateInfo.contact_email);
        formData.append("type", this.updateInfo.type);
        formData.append("reseller_type", this.updateInfo.reseller_type);
        formData.append("alarm_center", alarm_center);
        formData.append("pricelist", JSON.stringify(pricelist));
        formData.append("special_access", JSON.stringify(special_access));
        formData.append("whitelabel", this.updateInfo.whitelabel);
        formData.append("alternativ_order_email", this.updateInfo.alternativ_order_email);
        formData.append("alternativ_error_email", this.updateInfo.alternativ_error_email);

        if (this.updateImage) formData.append("image", this.updateImage);

        this.axios
          .put(`${process.env.VUE_APP_SERVER_URL}/reseller/${this.updateInfo._id}`, formData, headers)
          .then(async () => {
            // eslint-disable-line
            // SEC-334: the brand configuration, or its removal when White-label was turned off
            try {
              if (this.updateInfo.whitelabel) await this.saveBranding(this.updateInfo._id);
              // only when it was on and has been switched off: every other reseller save
              // must not touch branding at all
              else if (this.whitelabelAtOpen) await this.axios.delete(`${process.env.VUE_APP_SERVER_URL}/reseller/${this.updateInfo._id}/branding`);
            } catch (error) {
              this.handleError(error, this.$t("brands_page.saved_without_branding") + " " + ((error.response && error.response.data && (error.response.data.details ? error.response.data.details.join(". ") : error.response.data.message)) || ""), "top-right", 15000);
            }

            this.$emit("updateReseller");
            this.$modal.hide("update-reseller");
          })
          .catch((error) => {
            this.handleError(error);
          });
      });
    },

    fileChangeUpdate() {
      var vm = this;

      if (this.$refs.imageUpdate.files.length > 0) {
        this.updateImage = this.$refs.imageUpdate.files[0];

        let fileReader = new FileReader();
        fileReader.onload = function(e) {
          vm.previewImage = e.target.result;
        };
        fileReader.readAsDataURL(this.updateImage);
      } else {
        this.updateImage = null;
        this.previewImage = this.updateInfo.logo;
      }
    },

    setPriceZero(typeId, priceId) {
      let o = _.find(this.updateInfo.pricelist, { id: typeId });
      if (o) {
        let p = _.find(o.prices, { id: priceId });
        if (p) p.price = "0";
      }
    },

    resetSchemePrices(schemeId, priceId) {
      let originalScheme = _.find(this.pricelist, { id: schemeId });
      let updateScheme = _.find(this.updateInfo.pricelist, { id: schemeId });
      if (originalScheme && updateScheme) {
        let originalPrice = _.find(originalScheme.prices, { id: priceId });
        let updatePrice = _.find(updateScheme.prices, { id: priceId });
        if (originalPrice && updatePrice) updatePrice.price = originalPrice.price;
      }
    },

    hide(id) {
      this.$refs.formUpdateReseller.reset();
      this.$modal.hide(id);
    },
  },

  created() {
    this.modalWidth = window.innerWidth < MODAL_WIDTH ? window.innerWidth : MODAL_WIDTH;

    if (this.user.role == "admin") this.getAlarmCenters();
  },
};
</script>
